import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import './android15-detector';

if (environment.production) {
  enableProdMode();

  // Manter logs de erro para debugging do Google Auth
  const originalError = console.error;
  console.log = () => {};
  console.warn = () => {};
  
  // Manter console.error apenas para erros críticos como Google Auth
  console.error = (...args: any[]) => {
    const message = args.join(' ');
    if (message.includes('Google') || message.includes('Auth') || message.includes('Error')) {
      originalError.apply(console, args);
    }
  };
}
  

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
